import React, { useState, useEffect } from "react";
import "../../Styles/RepresentativeAutonomousForm.css";
import ApiService from "../../nhrc_apis/ApiService";

const { UploadAPI, AuthAPI } = ApiService;

function RepresentativeAutonomousForm({ onBack, onComplete, memberId, membershipId }) {

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= CAPTCHA ================= */
  const [captcha, setCaptcha] = useState({ id: null, question: "" });
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);

  /* ================= FORM DATA ================= */
  const [formData, setFormData] = useState({
    collegeName: "",
    collegeCode: "",
    designation: "",
    department: "",
    state: "",
    district: "",
    pinCode: "",
    address: "",
    idFront: null,
    idBack: null,
    experience: "",
    officialEmail: "",
    personalEmail: "",
    password: "",
    confirmPassword: "",
    mobile: "",
  });

  /* ================= CAPTCHA LOAD ================= */
  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = async () => {
    try {
      const res = await AuthAPI.getCaptcha();
      setCaptcha({
        id: res?.data?.captcha_id,
        question: res?.data?.question,
      });
      setCaptchaAnswer("");
      setCaptchaValid(false);
    } catch {
      alert("Captcha load failed");
    }
  };

  /* ================= INPUT ================= */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  /* ================= CAPTCHA VERIFY ================= */
  const verifyCaptcha = async () => {
    try {
      await AuthAPI.verifyCaptcha({
        captcha_id: captcha.id,
        answer: captchaAnswer,
      });
      setCaptchaValid(true);
      alert("Captcha Verified ✅");
    } catch {
      setCaptchaValid(false);
      alert("Invalid captcha ❌");
      loadCaptcha();
    }
  };

  /* ================= VALIDATION ================= */
  const validateForm = () => {
    if (!formData.collegeName) return alert("Enter College Name");
    if (!formData.collegeCode) return alert("Enter College Code");
    if (!formData.designation) return alert("Enter Designation");
    if (!formData.department) return alert("Enter Department");

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return false;
    }

    if (!captchaValid) {
      alert("Verify captcha");
      return false;
    }

    return true;
  };

  /* ================= FILE UPLOAD ================= */
  const uploadFile = async (file, type) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("membership_id", membershipId);
    fd.append("file_type", type);

    const res = await UploadAPI.uploadFile(fd);

    return res.data?.file_path || "";
  };

  /* ================= SUBMIT ================= */
  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const front = await uploadFile(formData.idFront, "representative_front");
      const back = await uploadFile(formData.idBack, "representative_back");

      /* 🔥 IMPORTANT FIX: FLAT PAYLOAD */
      const payload = {
        member_id: memberId,
        membership_id: membershipId,

        college_name: formData.collegeName,
        college_code: formData.collegeCode,
        designation: formData.designation,
        department: formData.department,
        state: formData.state,
        district: formData.district,
        pincode: formData.pinCode,
        college_address: formData.address,
        experience: formData.experience,
        mobile_number: formData.mobile,

        official_mail_id: formData.officialEmail,
        personal_email: formData.personalEmail,
        password: formData.password,

        id_front: front,
        id_back: back,

        captcha_id: captcha.id,
        captcha_answer: captchaAnswer,
      };

      console.log("✅ FINAL PAYLOAD:", payload);

      await onComplete(payload);

      setShowSuccess(true);

    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.detail || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tpo-autonomous-wrapper123">

      {!showSuccess ? (
        <div className="tpo-autonomous-card123">

          <div className="tpo-autonomous-title123">
            <h2>Representative Autonomous Details</h2>
            <div className="tpo-title-divider123">
              <span className="tpo-line123" />
              <span className="tpo-dot123" />
              <span className="tpo-line123" />
            </div>
          </div>

          <form onSubmit={handleRegister}>

            <div className="tpo-field-group123">
              <label>College Name*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="collegeName" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>College Code*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="collegeCode" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Designation*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="designation" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Department*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="department" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>State*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="state" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>District*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="district" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Pin Code*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="pinCode" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Address*</label>
              <div className="tpo-input-icon-wrap123 tpo-textarea-wrap123">
                <textarea name="address" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>ID Front*</label>
              <div className="tpo-file-row123">
                <input type="file" name="idFront" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>ID Back*</label>
              <div className="tpo-file-row123">
                <input type="file" name="idBack" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Experience*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="experience" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Official Email*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="officialEmail" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Personal Email*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="personalEmail" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Password*</label>
              <div className="tpo-input-icon-wrap123">
                <input type="password" name="password" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Confirm Password*</label>
              <div className="tpo-input-icon-wrap123">
                <input type="password" name="confirmPassword" onChange={handleChange} />
              </div>
            </div>

            <div className="tpo-field-group123">
              <label>Mobile*</label>
              <div className="tpo-input-icon-wrap123">
                <input name="mobile" onChange={handleChange} />
              </div>
            </div>

            {/* CAPTCHA */}
            <div className="tpo-field-group123 tpo-field-group-full123 tpo-captcha-group123">
              <label>Captcha Verification*</label>
              <div className="tpo-captcha-row123">
                <p className="tpo-captcha-box123">{captcha.question}</p>

                <div className="tpo-input-icon-wrap123 tpo-captcha-answer-wrap123">
                  <input
                    value={captchaAnswer}
                    onChange={(e) => setCaptchaAnswer(e.target.value)}
                  />
                </div>

                <button type="button" className="tpo-captcha-refresh-btn123" onClick={loadCaptcha}>
                  Refresh
                </button>

                <button type="button" className="tpo-captcha-verify-btn123" onClick={verifyCaptcha}>
                  Verify
                </button>
              </div>
              {captchaValid && (
                <span className="tpo-captcha-success123">✔ Captcha Verified Successfully!</span>
              )}
            </div>

            <div className="tpo-form-actions123">
              <button type="submit" className="tpo-btn-register123" disabled={loading}>
                {loading ? "Submitting..." : "Register"}
              </button>

              <button type="button" className="tpo-btn-back123" onClick={onBack}>
                Back
              </button>
            </div>

          </form>
        </div>
      ) : (
        <div className="tpo-autonomous-popup123">
          <h2>🎉 Success</h2>
          <button onClick={onBack}>Continue</button>
        </div>
      )}
    </div>
  );
}

export default RepresentativeAutonomousForm;